import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export default (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 560 160"
    height={160}
    width="100%"
    speed={2}
    {...props}
  >
    <rect x="0" y="0" rx="3" ry="3" width="100%" height="25" />
    <rect x="5%" y="39" rx="3" ry="3" width="90%" height="10" />
    <rect x="5%" y="55" rx="3" ry="3" width="90%" height="10" />
    <rect x="5%" y="71" rx="3" ry="3" width="90%" height="10" />

    {/*<rect x="0" y="56" width="410" height="6" rx="3"/>*/}
    {/*<rect x="0" y="72" width="380" height="6" rx="3"/>*/}
    {/*<rect x="0" y="88" width="178" height="6" rx="3"/>*/}
  </ContentLoader>
);
